import type { ScriptBlock } from "@gearbox-protocol/deploy-tools-shared";
import { cn, HelpTooltip } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { formatSeconds } from "utils";

interface BlockDriftProps {
  block: ScriptBlock;
  warningRange?: [number, number];
  displayOriginDrift?: boolean;
}

const BlockDrift: FC<BlockDriftProps> = props => {
  const { block, warningRange, displayOriginDrift } = props;
  const { timeDrift, originDrift } = block;
  if (!timeDrift) {
    return null;
  }
  const isWarning =
    !!warningRange &&
    (timeDrift < warningRange[0] || timeDrift > warningRange[1]);
  return (
    <>
      <span
        className={cn("border-slate-500 border-l ml-2 pl-2 text-slate-500", {
          "text-red-600": isWarning,
        })}
      >
        <span>{isWarning ? "⚠️ " : " "}</span>
        <span>Time drift: </span>
        <span>{formatSeconds(timeDrift)}</span>
        <HelpTooltip className="text-slate-500 -mt-1">
          TimeDrift is time delta in seconds from block timestamp to realtime.
          Positive means that fork ran into future and this can break price
          updates
        </HelpTooltip>
      </span>
      {displayOriginDrift && originDrift && (
        <span className="border-slate-500 border-l ml-2 pl-2 text-slate-500">
          Origin drift: {originDrift}
        </span>
      )}
    </>
  );
};

export default BlockDrift;
